import { JSXElementConstructor } from 'react';
import { css } from '@emotion/react';
import { ProColors } from '@treatwell/treatwell-aura';

export type MainTemplateProps = {
  HeaderComponent: JSXElementConstructor<object>;
  ProgressComponent: JSXElementConstructor<object>;
  ContentComponent: JSXElementConstructor<object>;
  FooterComponent: JSXElementConstructor<object>;
};

export function MainTemplate(props: MainTemplateProps): JSX.Element {
  const {
    HeaderComponent,
    ProgressComponent,
    ContentComponent,
    FooterComponent,
  } = props;
  return (
    <div>
      <div
        css={css({
          position: 'sticky',
          top: 0,
          backgroundColor: ProColors.white,
          zIndex: 100,
        })}
      >
        <HeaderComponent />
        <ProgressComponent />
      </div>

      <ContentComponent />

      <div
        css={css({
          position: 'fixed',
          bottom: 0,
          width: '100%',
          backgroundColor: ProColors.white,
          zIndex: 100,
        })}
      >
        <FooterComponent />
      </div>
    </div>
  );
}
